<template>
  <div id="priceage" style="width: 100%; height: 100%"></div>
</template>
<script>
import axios from "axios";
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var chartDom = document.getElementById("priceage");
    var myChart = echarts.init(chartDom);
    var option = {
      tooltip: {
        trigger: "axis",
      },
      color: ["#38e9a0", "#fc8d5c", "#e5cb08"],
      grid: {
        left: "12%",
        right: "6%",
        top: "15%",
        bottom: "8%",
      },
      legend: {
        data: ["最高价", "最低价", "平均价"],
        textStyle: {
          color: "#fff",
          padding: [0, 3], //文字与图形之间的左右间距
        },
      },
      xAxis: [
        {
          color: "#fff",
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          axisPointer: {
            type: "shadow",
          },
          axisLine: {
            //y轴线的颜色以及宽度
            show: false,
            lineStyle: {
              color: "#fff",
              width: 1,
              type: "solid",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "最低价",
          min: 0,
          max: 250,
          interval: 50,
          axisLabel: {
            formatter: "{value}元/标准箱",
          },
          axisLine: {
            //y轴线的颜色以及宽度
            show: false,
            lineStyle: {
              color: "#fff",
              width: 1,
              type: "solid",
            },
          },
        },
        {
          type: "value",
          name: "平均价",
          min: 0,
          max: 250,
          interval: 50,
          axisLabel: {
            //   formatter: '{value} 元/标准箱'
            show: false,
          },
          axisLine: {
            //y轴线的颜色以及宽度
            show: false,
            lineStyle: {
              color: "#fff",
              width: 1,
              type: "solid",
            },
          },
        },
      ],
      series: [
        {
          name: "最高价",
          type: "bar",
          tooltip: {
            valueFormatter: function (value) {
              return value + "元/标准箱";
            },
          },
          data: [225, 198, 204, 205, 195, 180, 210, 221, 242, 216, 204, 201],
        },
        {
          name: "最低价",
          type: "bar",
          tooltip: {
            valueFormatter: function (value) {
              return value + "元/标准箱";
            },
          },
          data: [193, 184, 196, 192, 180, 167, 174, 206, 211, 186, 180, 175],
        },
        {
          name: "平均价",
          type: "line",
          yAxisIndex: 1,
          tooltip: {
            valueFormatter: function (value) {
              return value + "元/标准箱";
            },
          },
          data: [
            208.91, 188.75, 201.03, 198.3, 186.39, 172.53, 185.48, 215.42,
            227.8, 197.16, 191.03, 186.19,
          ],

          // data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
